enum TaskGroupType {
    group = "group",
    individual = "individual"
}

export { TaskGroupType };
